var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.activity_items),function(model,index){return _c('ActivitieProdGridItem',{key:model.id,attrs:{"model":model}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }